import { QuickLinksCard } from '@features/workspace/components/shared/quick-links-card';

export function BankingQuickLinks() {
  const properties: Array<any> = [
    { link: '#', header: 'Report fraud', text: 'Access link' },
    { link: '#', header: 'Track disputes', text: 'Access link' },
    { link: '#', header: 'Transaction tracing', text: 'Access link' },
  ];

  return (
    <QuickLinksCard
      header="Banking quick access service requests"
      properties={properties}
    />
  );
}
